// extracted by mini-css-extract-plugin
var _1 = "SharingDropdownSelect-module__animateUploadProgressBarWidth--tuje2";
var _2 = "SharingDropdownSelect-module__animatedBackground--qA9F5";
var _3 = "SharingDropdownSelect-module__button--ubprh";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "button" }
